import React from "react";

export default function NotFound() {
    return(
        <>
            404 not found
        </>
    )
}